/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import FullscreenLoading from '@/components/loading/fullscreen';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { useCreditStore } from '@/stores/modules/credit';
import { useUserStore } from '@/stores/modules/user';
import { Toast } from 'vant';
import TrackingData from '@/shared/reportDataTracking';
import { useCreditCommon, useRetainPopup } from '@/composables/useCreditCommon.js';
// use composables
import { faceStartApi, faceEndApi } from '@/services/credit';
import { compareVersion } from '@/shared/compareVersion';
import { useBackButton } from '@/composables/clickAppBackBtn';
export default {
    __name: 'face',
    setup: function(__props) {
        var _useCreditCommon = useCreditCommon(), agreed = _useCreditCommon.agreed, PrivacyDataBox = _useCreditCommon.PrivacyDataBox;
        var _useRetainPopup = useRetainPopup(), CreditFirstRetainPopup = _useRetainPopup.CreditFirstRetainPopup, CreditSecondRetainPopup = _useRetainPopup.CreditSecondRetainPopup, isShowFirstRetainPopup = _useRetainPopup.isShowFirstRetainPopup, isShowSecondRetainPopup = _useRetainPopup.isShowSecondRetainPopup, showSecondRetainPopup = _useRetainPopup.showSecondRetainPopup, goAppHome = _useRetainPopup.goAppHome, goAppHomeSimple = _useRetainPopup.goAppHomeSimple;
        var setupBackPressed = useBackButton().setupBackPressed;
        var creditStore = useCreditStore();
        var userStore = useUserStore();
        var router = useRouter();
        var route = useRoute();
        var clickUploadTime = ref();
        var liveUrl = ref('');
        var signatureId = ref('');
        var isCredit = ref(Number(route.query.isCredit) || 0);
        var isAdvance = ref(Number(route.query.isAdvance) || 0);
        var needAdvanceFace = computed(function() {
            return compareVersion('1.0.6') && isAdvance.value === 1;
        });
        var onSubmit = function() {
            clickUploadTime.value = new Date();
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'liveness_auth_screen-recognize',
                taskState: 1
            }));
            console.log('start face');
            // credit:'0'  need-face:'1'
            if (needAdvanceFace.value) {
                startAdvanceFace();
            } else {
                yxhJsBridge.faceAuth(String(isCredit.value));
                FullscreenLoading.show();
                window.faceAuthResult = /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(res) {
                        return _ts_generator(this, function(_state) {
                            FullscreenLoading.hide();
                            console.log('face callback', JSON.parse(res));
                            handleFaceRecognitionResult(res);
                            return [
                                2
                            ];
                        });
                    });
                    return function(res) {
                        return _ref.apply(this, arguments);
                    };
                }();
            }
        };
        var startAdvanceFace = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _ref, faceScanTokenId, timeLeft, url;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                faceStartApi({
                                    facePoint: isCredit.value
                                })
                            ];
                        case 1:
                            _ref = _state.sent(), faceScanTokenId = _ref.faceScanTokenId, timeLeft = _ref.timeLeft, url = _ref.url;
                            if (timeLeft > 0) {
                                liveUrl.value = encodeURI(url + '&language=es');
                                signatureId.value = faceScanTokenId;
                                // 通知原生应用开启返回事件处理
                                yxhJsBridge.webOccupationBack('1'); // can delete, but suggest retain
                                // 处理原生应用的返回事件
                                window.localBackPressed = function() {
                                    console.log('back to fetch advance face result');
                                    fetchAdvanceFaceResult();
                                };
                            } else {
                                router.push({
                                    path: '/result',
                                    query: {
                                        retryPlan: retryPlan
                                    }
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function startAdvanceFace() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAdvanceFaceResult = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var resultInfo, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            liveUrl.value = '';
                            yxhJsBridge.webOccupationBack('1'); // can delete, but suggest retain
                            window.localBackPressed = function() {
                                console.log('back to home');
                                setupBackPressed();
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                faceEndApi(_object_spread_props(_object_spread({}, userStore.commonData), {
                                    darkCase: userStore.blackbox,
                                    adTracker: userStore.gaid,
                                    userTracker: userStore.appsflyerId,
                                    facePoint: isCredit.value,
                                    faceScanTokenId: signatureId.value,
                                    authType: 5
                                }))
                            ];
                        case 2:
                            resultInfo = _state.sent();
                            signatureId.value = '';
                            handleFaceRecognitionResult(JSON.stringify({
                                resultStatus: '0000',
                                resultMsg: 'success',
                                resultInfo: resultInfo
                            }));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log(error, 'faceEndApi error');
                            TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'liveness_auth_screen-recognition_result',
                                taskState: 0,
                                growArea: JSON.stringify({
                                    channel: isAdvance.value,
                                    msg: error.message
                                }),
                                eventIntervalSpan: new Date() - clickUploadTime.value
                            }));
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAdvanceFaceResult() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleFaceRecognitionResult = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(res) {
                var _JSON_parse, resultStatus, resultMsg, resultInfo, faceMatch, errorCause, timeLeft, retryPlan1, routeObj, _ref, path, query;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _JSON_parse = JSON.parse(res), resultStatus = _JSON_parse.resultStatus, resultMsg = _JSON_parse.resultMsg, resultInfo = _JSON_parse.resultInfo;
                            if (!(resultStatus !== '0000')) return [
                                3,
                                1
                            ];
                            TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'liveness_auth_screen-recognition_result',
                                taskState: 0,
                                growArea: JSON.stringify({
                                    channel: isAdvance.value,
                                    msg: resultMsg
                                }),
                                eventIntervalSpan: new Date() - clickUploadTime.value
                            }));
                            Toast(resultMsg);
                            return [
                                2
                            ];
                        case 1:
                            faceMatch = resultInfo.faceMatch, errorCause = resultInfo.errorCause, timeLeft = resultInfo.timeLeft, retryPlan1 = resultInfo.retryPlan;
                            if (!faceMatch) return [
                                3,
                                5
                            ];
                            TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'liveness_auth_screen-recognition_result',
                                taskState: 1,
                                growArea: JSON.stringify({
                                    channel: isAdvance.value,
                                    msg: 'pass'
                                }),
                                eventIntervalSpan: new Date() - clickUploadTime.value
                            }));
                            console.log('face success');
                            if (!(isCredit.value === 1)) return [
                                3,
                                2
                            ];
                            // loan
                            goAppHomeSimple();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                creditStore.reqCreditStep()
                            ];
                        case 3:
                            routeObj = _state.sent();
                            if ((routeObj === null || routeObj === void 0 ? void 0 : routeObj.path) !== '/face') {
                                router.push(routeObj);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                8
                            ];
                        case 5:
                            TrackingData.trackIdentify(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'liveness_auth_screen-recognition_result',
                                taskState: 0,
                                growArea: JSON.stringify({
                                    channel: isAdvance.value,
                                    msg: errorCause
                                }),
                                eventIntervalSpan: new Date() - clickUploadTime.value
                            }));
                            Toast(errorCause);
                            console.log('face error', errorCause, timeLeft, retryPlan1);
                            if (!(timeLeft <= 0)) return [
                                3,
                                6
                            ];
                            setTimeout(function() {
                                router.push({
                                    path: '/result',
                                    query: {
                                        retryPlan: retryPlan1
                                    }
                                });
                            }, 3000);
                            return [
                                3,
                                8
                            ];
                        case 6:
                            return [
                                4,
                                creditStore.reqCreditStep()
                            ];
                        case 7:
                            _ref = _state.sent(), path = _ref.path, query = _ref.query;
                            if (path !== '/face') {
                                router.push({
                                    path: path,
                                    query: _object_spread_props(_object_spread({}, query), {
                                        retryPlan: retryPlan1
                                    })
                                });
                            }
                            _state.label = 8;
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleFaceRecognitionResult(res) {
                return _ref.apply(this, arguments);
            };
        }();
        onMounted(function() {
            if (needAdvanceFace.value) {
                // 监听 postMessage 发送的消息
                window.addEventListener('message', function(event) {
                    // TODO: 添加链接
                    if (event.origin === 'https://' && typeof event.data === 'string') {
                        var data = JSON.parse(event.data);
                        if (data.info) {
                            fetchAdvanceFaceResult();
                        }
                    }
                });
            }
        });
        onUnmounted(function() {
            if (!needAdvanceFace.value) {
                window.faceAuthResult = function() {};
            }
        });
        return {
            __sfc: true,
            agreed: agreed,
            PrivacyDataBox: PrivacyDataBox,
            CreditFirstRetainPopup: CreditFirstRetainPopup,
            CreditSecondRetainPopup: CreditSecondRetainPopup,
            isShowFirstRetainPopup: isShowFirstRetainPopup,
            isShowSecondRetainPopup: isShowSecondRetainPopup,
            showSecondRetainPopup: showSecondRetainPopup,
            goAppHome: goAppHome,
            goAppHomeSimple: goAppHomeSimple,
            setupBackPressed: setupBackPressed,
            creditStore: creditStore,
            userStore: userStore,
            router: router,
            route: route,
            clickUploadTime: clickUploadTime,
            liveUrl: liveUrl,
            signatureId: signatureId,
            isCredit: isCredit,
            isAdvance: isAdvance,
            needAdvanceFace: needAdvanceFace,
            onSubmit: onSubmit,
            startAdvanceFace: startAdvanceFace,
            fetchAdvanceFaceResult: fetchAdvanceFaceResult,
            handleFaceRecognitionResult: handleFaceRecognitionResult
        };
    }
};
